import { useEffect, useRef, useState } from 'react';
import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  const projectsRef = useRef(null);
  const [targetProject, setTargetProject] = useState(null);

  useEffect(() => {
    // Parse URL parameters when the app loads
    const queryParams = new URLSearchParams(window.location.search);
    const projectId = queryParams.get('projectId');
    const showVideo = queryParams.get('showVideo');
    const showDetails = queryParams.get('showDetails'); // Add this line

    if (projectId) {
      // Scroll to projects section with a slight delay to allow rendering
      setTimeout(() => {
        const projectsSection = document.getElementById('projects');
        if (projectsSection) {
          projectsSection.scrollIntoView({ behavior: 'smooth' });

          // After scrolling, dispatch appropriate custom event
          setTimeout(() => {
            if (showVideo === 'true' || showVideo === '1') {
              window.dispatchEvent(
                new CustomEvent('openProjectVideo', {
                  detail: { projectId: parseInt(projectId, 10) }
                })
              );
            } else if (showDetails === 'true' || showDetails === '1') {
              window.dispatchEvent(
                new CustomEvent('openProjectDetails', {
                  detail: { projectId: parseInt(projectId, 10) }
                })
              );
            }
          }, 1000);
        }
      }, 500);
    }
  }, []);



  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Skills />
      <Projects ref={projectsRef} targetProject={targetProject} />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
